/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { CloseIcon } from 'assets/icons';
import { Button, Input } from 'components';
import { Globals } from 'utils';
import { ServicesService } from 'services';

type IonChangeEvent = React.ChangeEvent<HTMLInputElement>;

interface ModalCreateSpecialtyProps {
  specialty?: any
  onClose: (reload?: boolean) => void
}

const ModalCreateSpecialty = ({ specialty, onClose }: ModalCreateSpecialtyProps) => {

  const [form, setForm] = useState({
    specialty_id: '',
    name: '',
  });

  const onChange = (value: string | File, target: keyof typeof form) => {
    setForm({ ...form, [target]: value });
  }

  const validateForm = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    e.stopPropagation();

    if (!form.name)
      return Globals.showError('Debe ingresar el nombre');

    onSubmit();
  }

  const onSubmit = async () => {
    try {
      await ServicesService.createSpecialty(form);
      Globals.showSuccess('Especialidad creada');
      onClose(true);

    } catch (error) {
      Globals.showError('Ocurrió un error inesperado');
    }
  }

  useEffect(() => {
    setForm({
      specialty_id: specialty?.id,
      name: specialty?.name,
    });
  }, []);

  return (
    <form onSubmit={validateForm}>
      <header>
        <p className="title">Especialidad</p>
        <button type="button" className="close-btn" onClick={() => onClose()}>
          <img src={CloseIcon} alt="Cerrar" />
        </button>
      </header>

      <section className="body">
        <Input
          label="Nombres"
          value={form.name}
          onChange={(e: IonChangeEvent) => onChange(e.target.value, 'name')}
        />
      </section>

      <div className="actions">
        <Button type="button" onClick={() => onClose()} clear>Cancelar</Button>
        <Button type="submit">Aceptar</Button>
      </div>
    </form>
  );
}

export default ModalCreateSpecialty;